import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Tomos() {
  const tomos = [{
    emoji: '📘',
    title: 'Tomo 1 — La Biología del Caos',
    subtitle: 'Luz y Ritmos Circadianos',
    desc: 'Tu reloj biológico, la guerra de la luz azul, melatonina, cortisol y los protocolos de luz solar que resetean tu sistema desde el primer día.'
  }, {
    emoji: '📗',
    title: 'Tomo 2 — Nutrición y Suplementación Elite',
    subtitle: 'Mercado Local Argentino',
    desc: 'La cadena bioquímica del sueño, el stack de suplementos con evidencia real, guía de compra argentina con precios y marcas verificadas. Sin tirar plata en lo que no funciona.'
  }, {
    emoji: '📙',
    title: 'Tomo 3 — El Entorno Inviolable',
    subtitle: 'Temperatura, Oscuridad y Magnetismo',
    desc: 'Cómo convertir tu cuarto en una máquina de sueño profundo. Oscuridad total, temperatura óptima, ruido de enmascaramiento. El entorno que trabaja mientras dormís.'
  }, {
    emoji: '📕',
    title: 'Tomo 4 — Descarga Mental',
    subtitle: 'Hackeo de Ansiedad Pre-Sueño',
    desc: 'El protocolo para apagar la mente que no para. Brain dump, respiración 4-7-8, técnicas de regulación del sistema nervioso. Para cuando el problema no es el cuerpo — es la cabeza.'
  }, {
    emoji: '📓',
    title: 'Tomo 5 — Protocolos de Emergencia',
    subtitle: 'Micro-Siestas Estratégicas',
    desc: 'Qué hacer cuando dormiste mal y tenés que rendir igual. Power naps, protocolos de recuperación y el sistema de micro-siestas que usan los atletas de élite.'
  }, {
    emoji: '📔',
    title: 'Tomo 6 — Plan de 21 Días',
    subtitle: 'Optimización Total del Sueño',
    desc: 'El roadmap completo. Día por día. Semana por semana. De la implementación a la maestría en 21 noches con métricas claras y protocolos accionables cada día.'
  }];
  const includes = ['Protocolos accionables desde la primera noche', 'Checklists y matrices de implementación', 'Evidencia científica explicada sin tecnicismos', 'Adaptación 100% al contexto argentino', 'Precios, marcas y productos disponibles en ARG', 'Versión exprés para noches con poco tiempo', 'Log de seguimiento semanal incluido'];
  return <section className="py-20 relative" data-id="element-287">
      <div className="container mx-auto px-4" data-id="element-288">
        <div className="text-center mb-16" data-id="element-289">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white flex items-center justify-center gap-3" data-id="element-290">
            <span aria-hidden="true" data-id="element-291">📚</span> 6 TOMOS COMPLETOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-20" data-id="element-292">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-8 rounded-2xl bg-slate-800/30 border border-white/10 hover:border-amber-500/30 transition-colors group" data-id="element-293">
              <div className="text-4xl mb-4 group-hover:scale-110 transition-transform origin-left" data-id="element-294">
                {tomo.emoji}
              </div>
              <h3 className="text-xl font-bold text-white mb-1" data-id="element-295">
                {tomo.title}
              </h3>
              <h4 className="text-sm font-medium text-amber-500 mb-4" data-id="element-296">
                {tomo.subtitle}
              </h4>
              <p className="text-slate-400 leading-relaxed text-sm" data-id="element-297">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="max-w-3xl mx-auto p-8 md:p-10 rounded-3xl bg-slate-800/50 border border-slate-700" data-id="element-298">
          <h3 className="text-2xl font-display font-bold text-white mb-8 text-center" data-id="element-299">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-300">
            {includes.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="flex items-start gap-3" data-id="element-301">
                <CheckCircle2 className="w-5 h-5 text-teal-400 shrink-0 mt-0.5" data-id="element-302" />
                <span className="text-slate-300 text-sm leading-tight pt-0.5" data-id="element-303">
                  {item}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}